import React from 'react';
import { translate } from '../../../common/intl';
import { FBAutocompleteAsync, FBAutocompleteAsyncOption } from '..';
import { FBAffectedLhrSelectionProps } from './FBAffectedLhrSelection.types';
import useStyles from './FBAffectedLhrSelection.styles';
import { withFBAffectedLhrSelection } from './FBAffectedLhrSelection.wrap';

const getOptionLabel = (option: any) => translate('form.builder.deviation.affected.serial.numbers.lot.display', {
  docId: option?.precalc?.lshs_subtitle?.lhr?.label,
  lot: option?.precalc?.lshs_subtitle?.lot?.label,
  displayRevision: option?.displayRevision,
});

const FBAffectedLhrSelection: React.FunctionComponent<FBAffectedLhrSelectionProps> = ({
  isOutput,
  disabled,
  urlValues,
  ...props
}) => {
  const classes = useStyles();

  return (
    <FBAutocompleteAsync
      {...props}
      key={urlValues as unknown as string}
      label="lhrDeviation.affectedLots"
      type="affectedLhrSelection"
      optionId={FBAutocompleteAsyncOption.LHR}
      shouldReloadOnInit={true}
      urlValues={urlValues}
      multiple={true}
      withState
      gutter={false}
      disableChipDelete={disabled}
      getOptionLabel={getOptionLabel}
      {...{ disabled }}
      autoCompleteClasses={{
        root: `${classes.root} ${classes.deleteChip}`,
        inputRoot: classes.inputRoot,
        tag: classes.tag,
        endAdornment: classes.endAdornment,
        popper: classes.popper,
        paper: classes.paper,
        listbox: classes.listbox,
        option: classes.option,
      }}
    />
  );
};

export default withFBAffectedLhrSelection(FBAffectedLhrSelection);
